(function(){
    'use strict';
    
    var enquiryModal = document.getElementById('enquiry-modal');
    //var closeBtn = enquiryModal.querySelector('.modal__close-btn');
    var modalEnquiryBtn = document.getElementById('modal-enquiry-btn');

    if(modalEnquiryBtn !== null){
        modalEnquiryBtn.addEventListener('click', initAjaxModal);
    }

    function initAjaxModal(e) {
        e.preventDefault();
       
        var btn  = e.currentTarget;
        var ajaxUrl = btn.getAttribute('href');
        magnificFormAjax(ajaxUrl);
    }


    function magnificFormAjax(ajaxUrl){
        $.magnificPopup.open({
            fixedContentPos: true,
            /*closeMarkup: `<button class="mfp-close" aria-label="Close modal">
            ${require('src/modules/SVGs/html/modal-close.html')}
        </button>`,*/
            closeMarkup: '',
            items:{
                src: ajaxUrl,
                type: 'ajax',                
                
            },
            callbacks:{
                parseAjax: function(mfpResponse){
                   /* var tempData = `
                    <div class="modal" role="dialog" aria-labelledby="coure-enquiries-label" aria-modal="true">
                        <div class="modal__header">
                            <h3 id="coure-enquiries-label" class="modal__title">Course enquiries</h3>
                            
                        </div>
                        <div class="modal__content">`
                        tempData += mfpResponse.data    
                        tempData += `</div>
                    </div>                    
                `
                    
                    mfpResponse.data = tempData;*/
                },
                ajaxContentAdded: function() {
                    openEnquiryModal();
                }
            }

          });
    }

    function openEnquiryModal() {
        //if country exists we have loaded in a form
        var country = document.getElementById('country');
        
        if(country !== null){
            document.getElementById('country').onchange = onCountryChanged;
            onCountryChanged();
            document.getElementById('type').onchange = onCurrentStatusChanged;
            onCurrentStatusChanged();

            // Change the course title when the course is loaded
            var title = getMeta('title');
            var courseTitleField = document.querySelector('.modal #form1 input[name=course_title]');

            if (title && courseTitleField) {
                courseTitleField.value = title;
            }

            // Add event listener to submit button so we can ajax the submit
            var formSubmit = document.querySelector('.modal #form1 input[type=SUBMIT]');

            if(formSubmit) {
                formSubmit.removeEventListener('click', ajaxSubmitCourseForm);
                formSubmit.addEventListener('click', ajaxSubmitCourseForm);
            }
        }
    }

    function closeEnquiryModal() {
        enquiryModal.classList.remove('open');
    }


    // ----- form functions


    var recaptchaLoaded = false;

    function onloadCallback() {
        recaptchaLoaded = true;
    }
    function recaptchaTimeout() {
        document.getElementById('token').value = '';
    }
    function recaptchaCallback(token) {
        document.getElementById('token').value = token;
    }

    function validateCourseForm(event) {
        var typeVal = document.getElementById("type").value;
        var studyArea = document.getElementById("study_area").value;
        var levelTypeValue = document.getElementById("level_type").value;
        var postCode = document.getElementById("postcode").value;
        // Removed/add recaptch for dev
        //if (!recaptchaLoaded) {
        //    alert('Recaptcha check has not yet loaded');
        //    return false;
        //}
        var token = document.getElementById('token').value;
        if (token === '') {
            alert('Please ensure you are not a robot, and check the box at the bottom of the form.');
            return false;
        }
        if (!typeVal || typeVal === '') {
            alert('Please select your current status');
            return false;
        } else if ((document.querySelectorAll('#level_type option:not([value=""])').length > 0) && (!levelTypeValue || levelTypeValue === '')) {
            var alerts = {
                'highschool': 'Please select what year are you in',
                'nonschool': 'Please select which statement best describes you',
                'postgrad': 'Please select what level are you looking at studying',
                'international': 'Please select what type of international study are you interested in',
                'parent': 'Please select what is the current status of your child',
                'other': 'Please select what best describes you',
            }
            alert('Selection missing: ' + alerts[typeVal])
            return false
        } else if (!studyArea || studyArea === '') {
            alert('Please select your area of interest');
            return false;
        } else if (document.getElementById('country').value === "") {
            alert('Please select your country');
            return false;
        } else if ((document.getElementById('country').value === "2") && (!postCode || postCode === '')) {
            alert('Please enter your postcode');
            return false;
        } else {
            return true;
        }
    }

    function ajaxSubmitCourseForm(event) {
        // Stop the default event from firing
        event.preventDefault();

        // Check that the form is valid
        var formValid = validateCourseForm();

        if (formValid  === true) {

            // Get the form
            var submittedForm = getClosest(event.target, '#form1');
    
            // Get the url to open in the modal after submission complete
            var completionUrl = submittedForm.dataset.completionUrl;
            var failureUrl = submittedForm.dataset.failureUrl;
            event.target.disabled = true;

            event.target.value = 'Submitting';
    
            // Submit the form
            $.ajax({
                type: 'post',
                url: submittedForm.action,
                data: $(submittedForm).serialize(),
                success: function () {
                    magnificFormAjax(completionUrl);
                },
                error: function(){
                    magnificFormAjax(failureUrl);
                },

                complete: function () {
                    //magnificFormAjax(completionUrl);
                }
            });

        }


    }
    // ---------------------------------------------------------------   
    function onCountryChanged() {
        var val = document.getElementById('country').value;
        var displayStyle = val == 2 ? 'block' : 'none';
        document.getElementById('rowState').style.display = displayStyle;
        document.getElementById('rowPostcode').style.display = displayStyle;
    }
    // ---------------------------------------------------------------   
    function makeAndAddOption(text, value, select) {
        var opt = document.createElement('option')
        opt.innerHTML = text
        opt.value = value
        select.appendChild(opt)
    }
    // ---------------------------------------------------------------      
    function onCurrentStatusChanged() {
        // find the selection in status
        var selectedType = document.getElementById("type").value;

        // get a list of stuff to hide or show
        var stuffToProcess = document.querySelectorAll('#LevelType [data-show-if]')
        var optionsShowing = 0
        for (var i = 0; i < stuffToProcess.length; i++) {
            var item = stuffToProcess[i]
            if (item.getAttribute('data-show-if') === selectedType) {
                item.setAttribute('style', 'display: block')
                optionsShowing++
            } else {
                item.setAttribute('style', 'display: none')
            }
        }

        // now handle the selector..
        var selector = document.getElementById("level_type")

        // delete all the selector's content
        selector.innerHTML = ""

        // add just the right options...

        // always have the "please select", and choose it
        makeAndAddOption("Please select", "", selector)
        selector.value = ""

        if (selectedType === "highschool") {
            makeAndAddOption("Year 7 student", "year7", selector)
            makeAndAddOption("Year 8 student", "year8", selector)
            makeAndAddOption(" Year 9 student", "year9", selector)
            makeAndAddOption("Year 10 student", "year10", selector)
            makeAndAddOption("Year 11 student", "year11", selector)
            makeAndAddOption("Year 12 student", "year12", selector)
        }

        if (selectedType === "nonschool") {
            makeAndAddOption("Looking to upskil in my career path", "upskil_career", selector)
            makeAndAddOption("Looking to change career", "change_career", selector)
            makeAndAddOption("Took gap year/s, now ready to study", "took_gap", selector)
        }

        if (selectedType === "postgrad") {
            makeAndAddOption("Postgraduate Coursework", "post-coursework", selector)
            makeAndAddOption("Postgraduate Research", "post-research", selector)
            makeAndAddOption("Higher Degree by Research", "higher-research", selector)
        }

        if (selectedType === "international") {
            makeAndAddOption("Undergraduate", "undergraduate", selector)
            makeAndAddOption("Postgraduate", "postgraduate", selector)
            makeAndAddOption("Research", "research", selector)
            makeAndAddOption("Study Abroad", "studyabroad", selector)
            makeAndAddOption("Pathways (English Language)", "pathwaysenglish", selector)
        }

        if (selectedType === "parent") {
            makeAndAddOption("Year 7 student", "year7", selector)
            makeAndAddOption("Year 8 student", "year8", selector)
            makeAndAddOption(" Year 9 student", "year9", selector)
            makeAndAddOption("Year 10 student", "year10", selector)
            makeAndAddOption("Year 11 student", "year11", selector)
            makeAndAddOption("Year 12 student", "year12", selector)
            makeAndAddOption("They've already finished school", "schoolfinished", selector)
        }

        if (selectedType === "other") {
            makeAndAddOption("Teacher or Counsellor", "teacher", selector)
            makeAndAddOption("None of these", "nonea", selector)
        }

        // hide the whole thing, if there's just one option (which would be
        // the "please select" option)
        if (document.querySelectorAll('#level_type option').length > 1) {
           // selector.setAttribute('style', 'display: inherit')
           document.querySelector('#LevelType').setAttribute('style', 'display: block');
        } else {
           // selector.setAttribute('style', 'display: none');
            document.querySelector('#LevelType').setAttribute('style', 'display: none');
        }

    }

}());

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
var getClosest = function (elem, selector) {

    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    // Get closest match
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }

    return null;

};

// Function to get the metadata tag
function getMeta(metaName) {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content');
        }
    }

    return '';
}